/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { useIScroll } from "src/modules/pe-landing-module/hooks/useIScroll"
import { BACKGROUND_EFFECT_TYPE } from "../../../../data/interfaces"
import { IBackgroundProps } from "../Background" 
import { CSSBorder } from "src/libs/interfaces/layouts"
import { getCSSPartDemention } from "src/libs/utilities"

/* Protopia Ecosystem component */ 
const BackgroundPlain = ({section, ...props}: IBackgroundProps): JSX.Element => {
    const {color, opacity, image, image_opacity, parallax_speed, parallax_y_offset, effect, image_mask, stack, tile_size_px, tile_position_x, tile_position_y, tile_repeat, style } = (section.background || section.smart_background) || {}
    const bgRef = useRef(null)
    const scroll  = useIScroll( bgRef, effect ) 
    
    useEffect(() => {
        const border:CSSBorder = (section.smart_background || section.background)?.border
        addCSSClass(
            `section-bg-${section.id}`,
            `.section-bg-clr-${section.id} {
                background-color: ${ color };
                opacity: ${opacity || 1};
                z-index:${  stack === "image" ? 0 : 1};
                ${ !!border
                    ?
                    `border-style: ${ border.borderStyle || "solid" };
                    border-width: ${ getCSSPartDemention( border.borderWidth, ) };
                    border-color: ${ border.borderColor };
                    `
                    :
                    ``
                }
            }
            .section-bg-image-${section.id} {
                ${ image ? `background-image:url(${image});` : ``}
                opacity: ${image_opacity || 1};
                z-index:${ stack === "color" ? 0 : 1};
                ${ image_mask ? `mask-image: ${ image_mask};` : `` }
                ${ !!tile_size_px ? `background-size: ${tile_size_px}px;` : `` }
                background-repeat: ${ tile_repeat || "inherit" };
                ${ tile_position_x ? `background-position-x: ${ tile_position_x };`: '' }
                ${ tile_position_y ? `background-position-y: ${ tile_position_y }${ effect !== BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX && BACKGROUND_EFFECT_TYPE.FIXED ? "" : "!important" };`: "" }
            }`
        )        
        return () => {
            removeCSSClass(`section-bg-${section.id}`)
        }
    }, [ section.background, section.smart_background ])


    let poffset, backgroundAttachment = ""
    switch ( effect ) {
      case BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX:
        backgroundAttachment = "fixed"
        poffset = scroll * ( parallax_speed || -0.1 ) - ( parallax_y_offset || 4 )
        break
      case BACKGROUND_EFFECT_TYPE.FIXED:
        backgroundAttachment = "fixed"
        poffset = scroll - ( parallax_y_offset || 0 )
        break
      default:
        backgroundAttachment = ""
        poffset = tile_position_y
    }
 
    return <>
        <div className={`landing-section-bg-color section-bg-clr-${section.id}`} style={ style } />
        <div 
            className={`landing-section-bg-image section-bg-image-${section.id}`} 
            ref={bgRef} 
            style={{
                backgroundPositionY : poffset,
                backgroundAttachment
            }}
        />
      </>
}
export default BackgroundPlain